import styled from 'styled-components'
import Image from 'next/legacy/image'
import PropTypes from 'prop-types'
import { useCertificate } from 'querys/certificates'
import { Typography } from 'common/typography'
import CertificateSocial from './certificate-social'

const CertificatePreviewStyled = styled.div`
  .preview-container {
    filter: drop-shadow(0px 0px 270px rgba(97, 112, 216, 0.34));
    position: relative;
    .preview-name {
      font-weight: 600;
      position: absolute;
      top: 43%;
      right: 0;
      left: 0;
      text-align: center;
    }
  }
`

function CertificatePreview({ firstName, lastName }) {
  const { data } = useCertificate()

  const {
    course: { title }, user: { full_name }, preview, certificate_png, is_owner,
  } = data

  return (
    <CertificatePreviewStyled>
      <div className="preview-container">
        <Image
          width={588}
          height={454}
          src={certificate_png || preview}
          alt={`Preview del diploma del curso ${title} de ${full_name}`}
        />
        {is_owner && !certificate_png ? (
          <Typography small="smallBold" large="regularBold" className="preview-name" color="var(--neutral10)">
            {firstName}
            {' '}
            {lastName}
          </Typography>
        ) : ''}
      </div>
      <CertificateSocial />
    </CertificatePreviewStyled>
  )
}

CertificatePreview.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
}

export default CertificatePreview
